module.exports = __webpack_public_path__ + "img/telephone.c51ca6fb.svg";